import type { MilkdownPlugin } from "@milkdown/kit/ctx";

import { superscriptInputRule } from "../mark";
import { emDashInputRule, enDashInputRule, ellipsisInputRule } from "../plugin";

/// @internal
export const inputRules: MilkdownPlugin[] = [
  superscriptInputRule,
  // Typography: --- → —, -- → –, ... → …
  emDashInputRule,
  enDashInputRule,
  ellipsisInputRule,
];
